<div class="page-main">
  <!-- <Message></Message> -->
  <layoutMain :sideInfo="sideInfo" :isBack="state.isBack" :sidemenu="sidemenu" 
  @onClickInfoList="onClickInfoList" v-model:active="sideMenuActive" :breadcrumb="breadcrumb" 
  @onClickSideInfoList="onClickLang" @onClickContact="onClickContact" @onLogout="onLogout"
    @onClickBtn="onClickAddDevice" @onClickLicense="onClickLicense" :time="refreshTime" :btnIsShow="state.btnIsShow" :userName="user.name" :email="user.email">
    <template v-slot:header>
      <Header @onClickInfoList="onClickInfoList" @onClickLang="onClickLang" @onLogout="onLogout" :sideInfo="sideInfo" @onClickNotification="onClickNotification" @onClickContact="onClickContact" :userName="user.name" :email="user.email"></Header>
    </template>
    <template v-slot:content>
      <router-view></router-view>
    </template>
  </layoutMain>
</div>